

import Utils from '../utils'

export default {
  dev: {
    accountUrl: 'http://192.168.1.245:9217/',
    gatewayAPI: 'http://192.168.1.245:6890/',
    ljhUrl: 'http://192.168.1.245:8080/',
    materialUrl: 'http://192.168.1.245:9814/',
    phpUrl: 'http://localhost/',
    analysisUrl: 'http://192.168.1.245:9216/',
    imgHost: 'http://192.168.1.245:8000/',
    elongUrl: 'http://192.168.1.245:8088/',
    toolUrl: 'http://192.168.1.245:6874/',
    clientServerUrl:{
      loginAli:'https://xms.api.xbed.com.cn/',
      tooapiAli:'https://tool.api.xbed.com.cn/',
      clientAli:'https://client.api.xbed.com.cn/',
      analysisAli:'https://analysis.api.xbed.com.cn/',
      accountAli:'https://account.api.xbed.com.cn/',
      gateWayAli:'https://gateway.api.xbed.com.cn/',
      cleanerAli: 'https://cleaner.api.xbed.com.cn/',
      orderAli: 'https://order.api.xbed.com.cn/',
      doorLockAli: 'https://doorlock.api.xbed.com.cn/',
      userAli: 'https://user.api.xbed.com.cn/', // 192.168.1.245:6873
      roomAli: 'https://roomsystem.api.xbed.com.cn/',
      intelligentcsAli: 'https://intelligentcs.api.xbed.com.cn/',
      wechatAli: 'https://wechat.api.xbed.com.cn/'
    }
  },
  qa: {
    accountUrl: 'https://account-qa.internal.xbed.com.cn/',
    gatewayAPI: 'https://gateway-qa.internal.xbed.com.cn/',
    ljhUrl: 'https://xbedclean-qa.internal.xbed.com.cn/',
    materialUrl: 'http://112.74.27.47:9814/',
    phpUrl: 'https://oms-qa.internal.xbed.com.cn/',
    analysisUrl: 'https://analysis-qa.internal.xbed.com.cn/',
    imgHost: ' https://xbedcleanimg-qa.internal.xbed.com.cn/',
    elongUrl: 'https://elong-qa.internal.xbed.com.cn/',
    toolUrl: 'https://qiniu-callback-test.internal.xbed.com.cn/',
    clientServerUrl:{
      loginAli:'https://xms.api.xbed.com.cn/',
      tooapiAli:'https://tool.api.xbed.com.cn/',
      clientAli:'https://client.api.xbed.com.cn/',
      analysisAli:'https://analysis.api.xbed.com.cn/',
      accountAli:'https://account.api.xbed.com.cn/',
      gateWayAli:'https://gateway.api.xbed.com.cn/',
      cleanerAli: 'https://cleaner.api.xbed.com.cn/',
      orderAli: 'https://order.api.xbed.com.cn/',
      doorLockAli: 'https://doorlock.api.xbed.com.cn/',
      userAli: 'https://user.api.xbed.com.cn/',
      roomAli: 'https://roomsystem.api.xbed.com.cn/',
      intelligentcsAli: 'https://intelligentcs.api.xbed.com.cn/',
      wechatAli: 'https://wechat.api.xbed.com.cn/'
    }
  },
  ljhtest: {
    accountUrl: 'https://account-ljhtest-jjx989q3xdc6b4imtdc9hnlzkl5d0nlrs8ktohnanbi3z6.internal.xbed.com.cn/',
    gatewayAPI: 'https://omsljh-gateway.internal.xbed.com.cn/',
    ljhUrl: 'https://omsljh-xbedclean.internal.xbed.com.cn/',
    materialUrl: 'http://112.74.27.47:9814/',
    phpUrl: 'https://omsljh.internal.xbed.com.cn/',
    analysisUrl: 'https://omsljh-analysis.internal.xbed.com.cn/',
    imgHost: ' https://omsljh-xbedcleanimg.internal.xbed.com.cn/',
    elongUrl: 'https:/elong-test.internal.xbed.com.cn/',
    toolUrl: 'https://qiniu-callback-test.internal.xbed.com.cn/',
    clientServerUrl:{
      loginAli:'https://xms.api.xbed.com.cn/',
      tooapiAli:'https://tool.api.xbed.com.cn/',
      clientAli:'https://client.api.xbed.com.cn/',
      analysisAli:'https://analysis.api.xbed.com.cn/',
      accountAli:'https://account.api.xbed.com.cn/',
      gateWayAli:'https://gateway.api.xbed.com.cn/',
      cleanerAli: 'https://cleaner.api.xbed.com.cn/',
      orderAli: 'https://order.api.xbed.com.cn/',
      doorLockAli: 'https://doorlock.api.xbed.com.cn/',
      userAli: 'https://user.api.xbed.com.cn/',
      roomAli: 'https://roomsystem.api.xbed.com.cn/',
      intelligentcsAli: 'https://intelligentcs.api.xbed.com.cn/',
      wechatAli: 'https://wechat.api.xbed.com.cn/'
    }
  },
  stagingk8s: {
    accountUrl: 'https://account-staging-e5m7tkx9rp0iopw2q9b5mz8wr9ypuaytk3psfb55nrrcdq.internal.xbed.com.cn/',
    gatewayAPI: 'https://gateway.internal.xbed.com.cn/',
    ljhUrl: 'https://xbedclean.internal.xbed.com.cn/',
    materialUrl: 'http://112.74.27.47:9814/',
    phpUrl: 'https://oms.internal.xbed.com.cn/',
    analysisUrl: 'https://analysis.internal.xbed.com.cn/',
    imgHost: ' https://xbedcleanimg.internal.xbed.com.cn/',
    elongUrl: 'https://elong.internal.xbed.com.cn/',
    toolUrl: 'https://qiniu-callback.xbed.com.cn/',
    clientServerUrl:{
      loginAli:'https://xms.api.xbed.com.cn/',
      tooapiAli:'https://tool.api.xbed.com.cn/',
      clientAli:'https://client.api.xbed.com.cn/',
      analysisAli:'https://analysis.api.xbed.com.cn/',
      accountAli:'https://account.api.xbed.com.cn/',
      gateWayAli:'https://gateway.api.xbed.com.cn/',
      cleanerAli: 'https://cleaner.api.xbed.com.cn/',
      orderAli: 'https://order.api.xbed.com.cn/',
      doorLockAli: 'https://doorlock.api.xbed.com.cn/',
      userAli: 'https://user.api.xbed.com.cn/',
      roomAli: 'https://roomsystem.api.xbed.com.cn/',
      intelligentcsAli: 'https://intelligentcs.api.xbed.com.cn/',
      wechatAli: 'https://wechat.api.xbed.com.cn/'
    }
  },
  prepare: {
    accountUrl: 'https://account-staging-e5m7tkx9rp0iopw2q9b5mz8wr9ypuaytk3psfb55nrrcdq.internal.xbed.com.cn/',
    gatewayAPI: 'https://gategre.xbed.com.cn/',
    ljhUrl: '',
    phpUrl: 'https://goms.xbed.com.cn/',
    analysisUrl: 'http://120.25.104.235:9216/',
    imgHost: 'http://120.25.106.206:8000/',
    elongUrl: 'https://elong-gre.xbed.com.cn/',
    toolUrl: 'https://qiniu-callback.xbed.com.cn/',
    clientServerUrl:{
      loginAli:'https://xms.api.xbed.com.cn/',
      tooapiAli:'https://tool.api.xbed.com.cn/',
      clientAli:'https://client.api.xbed.com.cn/',
      analysisAli:'https://analysis.api.xbed.com.cn/',
      accountAli:'https://account.api.xbed.com.cn/',
      gateWayAli:'https://gateway.api.xbed.com.cn/',
      cleanerAli: 'https://cleaner.api.xbed.com.cn/',
      orderAli: 'https://order.api.xbed.com.cn/',
      doorLockAli: 'https://doorlock.api.xbed.com.cn/',
      userAli: 'https://user.api.xbed.com.cn/',
      roomAli: 'https://roomsystem.api.xbed.com.cn/',
      intelligentcsAli: 'https://intelligentcs.api.xbed.com.cn/',
      wechatAli: 'https://wechat.api.xbed.com.cn/'
    }
  },
  release: {
    accountUrl: 'https://account-production-u7jwhi17yiam1f90d86fuyhoou1sg5gptle782a081cm.xbed.com.cn/',
    gatewayAPI: 'https://gate.xbed.com.cn/',
    ljhUrl: '',
    // gatewayAPI: 'http://120.77.0.137:6890/',
    phpUrl: 'https://oms.xbed.com.cn/',
    analysisUrl: 'https://analysis-p.xbed.com.cn/',
    imgHost: 'http://112.74.24.16:8000/',
    elongUrl: 'https://elong.xbed.com.cn/',
    toolUrl: 'https://qiniu-callback.xbed.com.cn/',
    clientServerUrl:{
      loginAli:'https://xms.api.xbed.com.cn/',
      tooapiAli:'https://tool.api.xbed.com.cn/',
      clientAli:'https://client.api.xbed.com.cn/',
      analysisAli:'https://analysis.api.xbed.com.cn/',
      accountAli:'https://account.api.xbed.com.cn/',
      gateWayAli:'https://gateway.api.xbed.com.cn/',
      cleanerAli: 'https://cleaner.api.xbed.com.cn/',
      orderAli: 'https://order.api.xbed.com.cn/',
      doorLockAli: 'https://doorlock.api.xbed.com.cn/',
      userAli: 'https://user.api.xbed.com.cn/',
      roomAli: 'https://roomsystem.api.xbed.com.cn/',
      intelligentcsAli: 'https://intelligentcs.api.xbed.com.cn/',
      wechatAli: 'https://wechat.api.xbed.com.cn/'
    }
  },
  productionk8s: {
    accountUrl: 'https://account-production-u7jwhi17yiam1f90d86fuyhoou1sg5gptle782a081cm.xbed.com.cn/',
    gatewayAPI: 'https://gateway.xbed.com.cn/',
    ljhUrl: 'https://xbedclean.xbed.com.cn/',
    phpUrl: 'https://oms.xbed.com.cn/',
    analysisUrl: 'https://analysis-p.xbed.com.cn/',
    imgHost: ' https://xbedcleanimg.xbed.com.cn/',
    elongUrl: 'https://elong.xbed.com.cn/',
    toolUrl: 'https://qiniu-callback.xbed.com.cn/',
    clientServerUrl:{
      loginAli:'https://xms.api.xbed.com.cn/',
      tooapiAli:'https://tool.api.xbed.com.cn/',
      clientAli:'https://client.api.xbed.com.cn/',
      analysisAli:'https://analysis.api.xbed.com.cn/',
      accountAli:'https://account.api.xbed.com.cn/',
      gateWayAli:'https://gateway.api.xbed.com.cn/',
      cleanerAli: 'https://cleaner.api.xbed.com.cn/',
      orderAli: 'https://order.api.xbed.com.cn/',
      doorLockAli: 'https://doorlock.api.xbed.com.cn/',
      userAli: 'https://user.api.xbed.com.cn/',
      roomAli: 'https://roomsystem.api.xbed.com.cn/',
      intelligentcsAli: 'https://intelligentcs.api.xbed.com.cn/',
      wechatAli: 'https://wechat.api.xbed.com.cn/'
    }
  },
  other: {
    accountUrl: 'https://account:9217/',
    ljhUrl: '',
    gatewayAPI: Utils.findFromLocalStorage('vue-gatewayapi', 'http://120.25.106.243:6890/'),
    materialUrl: Utils.findFromLocalStorage('vue-materialurl', 'http://120.25.106.243:9814/'),
    phpUrl: Utils.findFromLocalStorage('vue-phpurl', 'https://omsdev.xbed.com.cn/'),
    analysisUrl: Utils.findFromLocalStorage('vue-analysisurl', 'http://120.25.106.243:9216/'),
    elongUrl: 'https://elong-test.xbed.com.cn/',
    toolUrl: 'https://qiniu-callback.xbed.com.cn/',
    clientServerUrl:{
      loginAli:'https://xms.api.xbed.com.cn/',
      tooapiAli:'https://tool.api.xbed.com.cn/',
      clientAli:'https://client.api.xbed.com.cn/',
      analysisAli:'https://analysis.api.xbed.com.cn/',
      accountAli:'https://account.api.xbed.com.cn/',
      gateWayAli:'https://gateway.api.xbed.com.cn/',
      cleanerAli: 'https://cleaner.api.xbed.com.cn/',
      orderAli: 'https://order.api.xbed.com.cn/',
      doorLockAli: 'https://doorlock.api.xbed.com.cn/',
      userAli: 'https://user.api.xbed.com.cn/',
      roomAli: 'https://roomsystem.api.xbed.com.cn/',
      intelligentcsAli: 'https://intelligentcs.api.xbed.com.cn/',
      wechatAli: 'https://wechat.api.xbed.com.cn/'
    }
  }
}



// WEBPACK FOOTER //
// ./src/config/index.js